<template>
      <div
        class="modal trader-info mng-acc-modal"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >{{ecnData.ecnShortName}} Edit</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <label for="tmcbrocker">Increase</label>
                  <input type="number" v-model="ecnData.increase" class="form-control" id="Return"   >
                </div>
                <div class="col-md-6">
                  <form>
                    <div class="form-group row">
                      <div class="col-sm-2">
                        <div class="form-check">
                          <input v-model="ecnData.active" class="form-check-input" type="checkbox" id="gridCheck1">
                          <label class="form-check-label" for="gridCheck1">
                            ACTIVE
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-2">
                        <div class="form-check">
                          <input v-model="ecnData.applyIncrease" class="form-check-input" type="checkbox" id="gridCheck1">
                          <label class="form-check-label" for="gridCheck1">
                            Apply Increase
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>  
                <div class="modal-footer">
                  <button class="btn btn-light" type="button" @click="$emit('close')">Cancel</button>
                  <button class="btn btn-success" type="button" @click="updateEcn()">SAVE</button>
                </div>
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
               <!-- <p v-if="error">
                  <ul>
                  <li class="alert alert-danger" role="alert">Account number is required.</li>
                  </ul>
              </p> -->
              
            </div>
          </div>
        </div>
      </div>
    </template>

    <script>
     import authService from "@/authService";
     import config from "@/config";

    export default {
        name: 'ecnModal',
        components :{
            
        },
        props: ['ecnData'],
        data() {
            return {
                loading : false
            };
        },
        methods: {   
          updateEcn(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.ecnData.increase =  this.ecnData.increase+"";
            this.ecnData.active =  this.ecnData.active ? "true" : "false";
            this.ecnData.applyIncrease =  this.ecnData.applyIncrease ? "true" : "false";
            this.$http
            .put(
              config.baseUrlBidSide +
                "/ecn",
                this.ecnData,
                auth
                
            )
            .then(() => {
                this.$alert("ECN Updated","","success");
                this.loading = false;
                this.$emit('close');               
            }).catch(() => this.loading = false) 
          }
        },
        mounted() {
        
          
        }
    };
    </script>